import i18n from "@/i18n/index";
import { DIAGRAM_PLUGINS } from "./plugins";

export const PLUGIN_CATEGORIES = [
    {
        title: "Non displaying",
        displayPreview: false,
        plugins: [
            {
                id: "CLASS_PROPERTY",
                title: "Class Property",
                plugin: DIAGRAM_PLUGINS.ClassProperty,
                type: "rectangle",
                hasOwnState: true,
                displayPreview: false
            },
            {
                id: "ANCHORED_HEXAGON",
                title: "Hexagon Anchored",
                plugin: DIAGRAM_PLUGINS.CircleDisplayPlugin,
                type: "rectangle",
                hasOwnState: true,
                displayPreview: false
            },
            {
                id: "DATA_MODEL_CLASS",
                title: "Class",
                plugin: DIAGRAM_PLUGINS.DataModelClass,
                type: "rectangle",
                hasOwnState: true,
                displayPreview: false,
                defaultSize: {
                    width: 200,
                    height: 200
                }
            }
        ]
    },
    {
        title: i18n.t("diagrams.activities"),
        plugins: [
            {
                id: "TASK_PLUGIN",
                title: "Task",
                plugin: DIAGRAM_PLUGINS.TaskPlugin,
                type: "rectangle"
            },
            {
                id: "APPROVAL_PLUGIN",
                title: "Decisions",
                plugin: DIAGRAM_PLUGINS.ApprovalMatrixPlugin,
                type: "rectangle"
            },
            {
                id: "EXTERNAL_PLUGIN",
                title: "External task",
                plugin: DIAGRAM_PLUGINS.ExternalTaskPlugin,
                type: "rectangle"
            },
            {
                id: "GENERATE_DOCUMENT_PLUGIN",
                title: "Generate Documents",
                plugin: DIAGRAM_PLUGINS.GenerateDocumentPlugin,
                type: "rectangle"
            },
            {
                id: "API_PLUGIN",
                title: "Call API",
                plugin: DIAGRAM_PLUGINS.ApiPlugin,
                type: "rectangle"
            },
            {
                id: "BLOCKCHAIN_PLUGIN",
                title: "Blockchain",
                plugin: DIAGRAM_PLUGINS.BlockchainPlugin,
                type: "rectangle"
            },
            {
                id: "DATA_EXPORT_PLUGIN",
                title: "Data Export",
                plugin: DIAGRAM_PLUGINS.DataExportPlugin,
                type: "rectangle"
            },
            {
                id: "EXPOSE_API_PLUGIN",
                title: "Expose API",
                plugin: DIAGRAM_PLUGINS.ExposeApiPlugin,
                type: "rectangle"
            },
            {
                id: "BLOCKCHAIN_EVENT_PLUGIN",
                title: "Blockchain Event",
                plugin: DIAGRAM_PLUGINS.BlockchainEventPlugin,
                type: "rectangle"
            },
            {
                id: "PROCESS_PLUGIN",
                title: "Process",
                plugin: DIAGRAM_PLUGINS.ProcessPlugin,
                type: "rectangle"
            },
            {
                id: "ADVANCED_LOGIC_PLUGIN",
                title: "Advanced Logic",
                plugin: DIAGRAM_PLUGINS.AdvancedLogicPlugin,
                type: "rectangle"
            }
        ]
    },
    {
        title: i18n.t("diagrams.events"),
        plugins: [
            {
                id: "GENERAL_START_PLUGIN",
                title: "Start",
                plugin: DIAGRAM_PLUGINS.GeneralStartPlugin,
                type: "rectangle"
            },
            {
                id: "EXTERNAL_SOURCE_PLUGIN",
                title: "Start from external source",
                plugin: DIAGRAM_PLUGINS.StartExternalPlugin,
                type: "circle"
            },
            {
                id: "GENERAL_END_PLUGIN",
                title: "End",
                plugin: DIAGRAM_PLUGINS.GeneralEndPlugin,
                type: "circle"
            },
            {
                id: "START_BLOCKCHAIN_EVENT_PLUGIN",
                title: "Start from Blockchain",
                plugin: DIAGRAM_PLUGINS.StartBlockchainEventPlugin,
                type: "rectangle"
            }
        ]
    },
    {
        title: i18n.t("diagrams.gateways"),
        plugins: [
            {
                id: "EXCLUSIVE_GATEWAY_PLUGIN",
                title: "Exclusive gateway",
                plugin: DIAGRAM_PLUGINS.ExclusiveGatewayPlugin,
                type: "rotated"
            },
            {
                id: "PARALLEL_GATEWAY_PLUGIN",
                title: "Parallel gateway",
                plugin: DIAGRAM_PLUGINS.ParallelGatewayPlugin,
                type: "rotated"
            },
            {
                id: "JOIN_GATEWAY_PLUGIN",
                title: "Join gateway",
                plugin: DIAGRAM_PLUGINS.JoinGatewayPlugin,
                type: "rotated"
            }
        ]
    }
];
